import * as React from "react";
import { useEffect } from "react";
import "./headerViewStyles.css";
import { LanguageChangeButton } from "../../LanguageChangeButton";
import { useTranslation } from "react-i18next";
import { useFocusable } from "../../../utils/Helpers";
import { focusManager } from "../../../utils/Focus";
import { PublicBeta } from "../public-beta/PublicBeta";
export var HeaderView = function (_a) {
    var navigate = _a.navigate;
    var t = useTranslation().t;
    useEffect(function () {
        focusManager.registerGroup({ name: "main-navbar", position: 1 });
    }, [navigate, focusManager]);
    var homeRef = useFocusable({
        group: "main-navbar",
        index: 0,
        onKeyDown: function () { return navigate("home"); },
    });
    var movieRef = useFocusable({
        group: "main-navbar",
        index: 1,
        onKeyDown: function () { return navigate("movies", { movieType: "movie" }); },
    });
    var seriesRef = useFocusable({
        group: "main-navbar",
        index: 2,
        onKeyDown: function () { return navigate("tv-shows", { movieType: "series" }); },
    });
    var searchButtonRef = useFocusable({
        group: "main-navbar",
        index: 3,
        onKeyDown: function () { return navigate("search"); },
    });
    // LanguageChangeButton 4
    var profileButtonRef = useFocusable({
        group: "main-navbar",
        index: 5,
        onKeyDown: function () { return navigate("profiles"); },
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "header-container header", id: "main-navbar" },
            React.createElement("div", { className: "gradient" }),
            React.createElement("div", { className: "caveaplus-logo" }),
            React.createElement("div", { className: "header-menu-left" },
                React.createElement("p", { ref: homeRef, tabIndex: 0, className: "menu-item" },
                    React.createElement("span", null, t("header.home"))),
                React.createElement("p", { tabIndex: 0, ref: movieRef, className: "menu-item" },
                    React.createElement("span", null, t("header.movies"))),
                React.createElement("p", { tabIndex: 0, ref: seriesRef, className: "menu-item tv-shows-menu-item" },
                    React.createElement("span", null, t("header.tv_shows")))),
            React.createElement("div", { className: "header-menu-right" },
                React.createElement("div", { tabIndex: 0, ref: searchButtonRef, className: "search-icon" }),
                React.createElement(LanguageChangeButton, { focusRaw: ["main-navbar", 4] }),
                React.createElement("button", { tabIndex: 0, ref: profileButtonRef, className: "manage-profile" },
                    React.createElement("span", null, t("header.manage_profile"))))),
        React.createElement(PublicBeta, null)));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/header/HeaderView.tsx
// module id = 110
// module chunks = 1